
export default class StateStatus {
    static idle = 'idle'
    static loading = 'loading'
    static succeeded = 'succeeded'
    static failed = 'failed'
}
